import React, { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Bare overlay + portal, equivalent to MUI's unstyled `Modal`.
 * Renders nothing when `open` is false. Closes on Escape or backdrop click.
 */
const Modal = ({ open, onClose, children, className = "" }) => {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.(event, "escapeKeyDown");
    };
    document.addEventListener("keydown", handleKeyDown);

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = originalOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      // Filho direto nunca passa da tela: se o conteúdo for maior, ele rola
      className={`fixed inset-0 z-[1300] flex bg-black/50 [&>*]:max-h-full [&>*]:overflow-y-auto ${className}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.(event, "backdropClick");
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default Modal;
